import { ListItem, ListItemText } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

const SimpleSidebarComponent = ({ href, name }: any) => {
    return (
        <ListItem
            button
            component={RouterLink}
            to={href}
            style={{ cursor: "pointer" }}
        >
            <ListItemText primary={name} />
        </ListItem>
    );
};

export default SimpleSidebarComponent;
